import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouterStateService {
  public readonly redirectUrl = signal<string>(null);
}
